import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuConfig from "./MenuConfig";

const ContiMenu = ({ collapsed, userPrivileges, onMenuItemClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);
  const selectedKey = location.pathname;
  const hasAccess = (item) => !item.privilege || userPrivileges?.includes(item.privilege);

  useEffect(() => {
    if (collapsed) {
      setOpenKeys([]);
      return;
    }
    const keys = [];
    const collect = (menu) => {
      menu.forEach((item) => {
        const hasSelectedChild = item.children?.some((child) => child.key === selectedKey) ?? false;
        if (item.children && (item.defaultOpen || hasSelectedChild)) {
          keys.push(item.key);
          collect(item.children);
        }
      });
    };
    collect(MenuConfig);
    setOpenKeys(keys);
  }, [collapsed, selectedKey]);

  const renderMenu = (menu) => {
    return menu.filter(hasAccess).map((item) => {
      const isSelected = selectedKey === item.key;
      const hasSelectedChild = item.children?.some((child) => child.key === selectedKey) ?? false;
      const applyHighlight = collapsed && hasSelectedChild ? true : isSelected;
      return (
        <div key={item.key} className="relative">
          {collapsed && item.children ? (
            <Dropdown
              placement="rightTop"
              trigger={["hover"]}
              dropdownRender={() => (
                <div className="flex flex-col gap-2 p-2 bg-white rounded-lg">
                  {item.children.filter(hasAccess).map((child) => (
                    <Button
                      key={child.key}
                      type="text"
                      onClick={() => {
                        navigate(child.key);
                        onMenuItemClick?.();
                      }}
                      className={`p-2 font-inter rounded-lg cursor-pointer text-sm ${child.key === selectedKey ? "bg-[#04C6BD] text-white" : "hover:bg-gray-300"}`}
                    >
                      {child.label}
                    </Button>
                  ))}
                </div>
              )}
            >
              {/* parent trigger */}
              <div className={`flex items-center text-sm justify-center mx-3 my-2 cursor-pointer px-4 py-2 rounded-xl transition-colors ${applyHighlight ? "bg-[#04C6BD] text-white shadow-xl" : "hover:bg-gray-200"}`}>
                {item.icon && <FontAwesomeIcon icon={item.icon} className="w-5 h-5" />}
              </div>
            </Dropdown>
          ) : (
            <>
              <div
                onClick={() => {
                  if (item.children) {
                    setOpenKeys((prev) =>
                      prev.includes(item.key)
                        ? prev.filter((k) => k !== item.key)
                        : [...prev, item.key]
                    );
                  } else {
                    navigate(item.key);
                    onMenuItemClick?.();
                  }
                }}
                className={`flex items-center ${item.isParent === true ? "text-base" : "text-sm"} ${collapsed ? "justify-center mx-3 my-2" : "gap-2"} cursor-pointer px-4 py-2 rounded-xl transition-colors ${applyHighlight ? "bg-[#04C6BD] text-white shadow-xl" : "hover:bg-gray-200 "}`}
              >
                {item.icon && <FontAwesomeIcon icon={item.icon} className="w-5 h-5 " />}
                {!collapsed && <span className="font-bold ml-2">{item.label}</span>}
              </div>

              {!collapsed && item.children && openKeys.includes(item.key) && (
                <div className="ml-6 mt-1 flex flex-col gap-1 !text-sm">
                  {renderMenu(item.children)}
                </div>
              )}
            </>
          )}
        </div>
      );
    });
  };

  return (
    <div className="self-center w-[90%] overflow-visible">
      {renderMenu(MenuConfig)}
    </div>
  );
};

export default ContiMenu;